import { getBnoCategory } from "@/utils/bnoCategoriesUtil"
import _ from 'lodash'

const commandMap = {
  hasContent:
    (content, allInput) => allInput[content],

  allOf:
    (content, allInput) => content.every((item) => callSubFunction(item, allInput)),

  oneOf:
    (content, allInput) => content.some((item) => callSubFunction(item, allInput)),

  greaterThan:
    (bc, allInput) => {
      const content = Object.keys(bc)[0]
      return allInput[content] && Number.isInteger(Number(allInput[content])) && allInput[content] > bc[content]
    },

  elementsOf:
    (content, allInput) => {
      return content[1].indexOf(allInput[content[0]]) > -1
    },

  bno: (content, allInput) => {
    return content.indexOf(getBnoCategory(allInput['bno'])) > -1
  }
}

const callSubFunction = (item, allInput) => commandMap[Object.keys(item)[0]](item[Object.keys(item)[0]], allInput)

export const isAllDependencyFullfilled = (dependency, allInput) => {
  if (dependency == null) {
    return true
  }

  return dependency.every(dependencyItem => {
    return callSubFunction(dependencyItem, allInput)
  })
}

export const finalizeFormInputs = (formInputs, allFields) => {

  let normalizedFormInputs = {}

  for (let group in allFields) {
    for (let subgroup in allFields[group]) {
      if ('key' in allFields[group][subgroup]) {
        if (formInputs[subgroup] !== null && isAllDependencyFullfilled(allFields[group][subgroup]['dependency'], formInputs)) {
          if (!(group in normalizedFormInputs)) {
            normalizedFormInputs[group] = {}
          }

          const isNumber = _.find(allFields[group][subgroup]['validation'], {'type': 'number'})
          
          normalizedFormInputs[group][subgroup] = !!isNumber ? Number(formInputs[subgroup]) : formInputs[subgroup]
        }
      } else {
        for (let key in allFields[group][subgroup]) {
          if (formInputs[key] !== null && isAllDependencyFullfilled(allFields[group][subgroup][key]['dependency'], formInputs)) {
            
            if (typeof(formInputs[key]) === 'object') {
              if (Object.values(formInputs[key]).every(value => value === null)) {
                continue
              }
            }

            if (!(group in normalizedFormInputs)) {
              normalizedFormInputs[group] = {}
            }

            const isNumber = _.find(allFields[group][subgroup][key]['validation'], {'type': 'number'})
            
            normalizedFormInputs[group][key] = !!isNumber ? Number(formInputs[key]) : formInputs[key]
          }
        }
      }
    }
  }

  return normalizedFormInputs
}
